<app-custom-camera
  *ngIf="step === 'capture'"
  [initialMode]="cameraInitialMode"
  (onCameraFinishedJob)="initResultStep($event)"
  (onCameraLeave)="modalComponent.hide()"
>
</app-custom-camera>

<video
  *ngIf="media?.type === 'video'"
  #thumbnailVideoEl
  class="thumbnail-video-source"
  [src]="thumbnailVideoSrc"
  muted
  playsinline
  preload="auto"
></video>

<div *ngIf="media && step === 'preview'" class="add-media-preview-screen">
  <div class="add-media-preview-stage">
    <div *ngIf="isPreparingPreview" class="add-media-preview-loading">
      <i class="pi pi-spin pi-spinner add-media-preview-spinner"></i>
    </div>
    <app-native-video-preview
      *ngIf="media.type === 'video' && !isPreparingPreview"
      [nativeSrc]="isNative ? media?.filePath : null"
      [fallbackFile]="file"
      [fallbackSrc]="thumbnailVideoSrc"
      [previewPresetId]="selectedFilterPreset"
      [forceFallback]="shouldForceFallbackVideoPreview()"
      [enableSkeleton]="false"
      (loadingChange)="onVideoPreviewLoadingChange($event)"
    ></app-native-video-preview>
    <div *ngIf="media.type === 'video' && !isPreparingPreview && isVideoPreviewLoading" class="add-media-preview-loading">
      <i class="pi pi-spin pi-spinner add-media-preview-spinner"></i>
    </div>
    <div
      *ngIf="media.type === 'image' && getCurrentImagePreviewSource() && !isPreparingPreview"
      class="add-media-image add-media-image--preview"
      [style.backgroundImage]="'url(' + getCurrentImagePreviewSource() + ')'"
    ></div>
  </div>
  <div class="add-media-filter-rail" *ngIf="media">
    <button
      *ngFor="let preset of filterPresets"
      type="button"
      class="add-media-filter-option"
      [class.is-active]="isFilterSelected(preset.id)"
      (click)="selectFilterPreset(preset.id)"
    >
      <span
        class="add-media-filter-option__swatch"
        [class.add-media-filter-option__swatch--empty]="!getFilterSwatchSource(preset.id)"
        [style.backgroundImage]="getFilterSwatchSource(preset.id) ? 'url(' + getFilterSwatchSource(preset.id) + ')' : null"
      ></span>
      <span class="add-media-filter-option__label">
        {{ preset.labelKey | translate }}
      </span>
    </button>
  </div>
</div>

<div *ngIf="media && step === 'details'" class="add-media-details">
  <div *ngIf="media.type === 'image' && getCurrentImagePreviewSource()" class="add-media-image"
       [style.backgroundImage]="'url(' + getCurrentImagePreviewSource() + ')'"></div>

  <div *ngIf="media.type === 'video'" class="add-media-thumbnail">
    <img *ngIf="thumbnailDataUrl" [src]="thumbnailDataUrl" alt="thumbnail" />
    <button type="button" class="p-button p-button-text thumbnail-button" (click)="openThumbnailPicker()">
      {{'shared.modal.component.add_media.button.thumbnail' | translate}}
    </button>
  </div>

  <div class="add-media-caption p-fluid">
    <div class="p-field p-float-label p-input-icon-left">
      <i class="pi pi-pencil"></i>
      <textarea id="mediaCaption" [rows]="1" pInputTextarea autoResize="autoResize" type="text"
                [(ngModel)]="caption"
      ></textarea>
      <label for="mediaCaption">{{'shared.modal.component.add_media.caption.label' | translate }}</label>
    </div>
  </div>
</div>

<div *ngIf="media && step === 'thumbnail'" class="add-media-thumbnail-picker">
  <div class="add-media-thumbnail-preview">
    <img *ngIf="thumbnailDataUrl" [src]="thumbnailDataUrl" alt="thumbnail" />
  </div>
  <div class="add-media-thumbnail-controls">
    <p-slider
      [min]="0"
      [max]="videoDuration || 1"
      [step]="0.1"
      [disabled]="!videoDuration"
      [ngModel]="thumbnailTime"
      (ngModelChange)="onThumbnailTimeChange($event)"
    ></p-slider>
<!--    <button type="button" class="p-button p-button-text" (click)="cancelThumbnailPicker()">-->
<!--      {{'shared.modal.component.add_media.button.thumbnail_cancel' | translate}}-->
<!--    </button>-->
  </div>
</div>
